import { PopupNotificationActions } from './actions';
import * as constants from './constants';
import {
  IPopupNotificationsState,
  POPUP_NOTIFICATION_INITIAL_STATE,
} from './state';

export function popupNotifications(
  state: IPopupNotificationsState = POPUP_NOTIFICATION_INITIAL_STATE,
  action: PopupNotificationActions
): IPopupNotificationsState {
  switch (action.type) {
    case constants.POPUP_NOTIFICATION_ENQUEUED: {
      return [
        ...state,
        {
          key: action.key,
          notification: action.notification,
        },
      ];
    }

    case constants.POPUP_NOTIFICATION_CLOSED: {
      const newNotificationList = state.map((notificationData) =>
        action.dismissAll || notificationData.key === action.key
          ? { ...notificationData, dismissed: true }
          : { ...notificationData }
      );

      return [...newNotificationList];
    }

    case constants.POPUP_NOTIFICATION_REMOVED: {
      const newNotificationList = state.filter(
        (notificationData) => notificationData.key !== action.key
      );

      return [...newNotificationList];
    }

    default:
      return state;
  }
}
